import React, { Fragment, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useStoreActions, useStoreState } from 'easy-peasy';
import ReviewHeader from './components/ReviewHeader';
import ReviewFilter from '../../shared/components/ReviewFilter/ReviewFilter';
import ReviewGallery from '../../shared/components/ReviewGallery/ReviewGallery';
import LiveFiltersMock from '../../redux/reducers/mocks/live-filters';
import ReviewsContentMock from '../../redux/reducers/mocks/review-content';
import DeliveriesMock from '../../redux/reducers/mocks/deliveries';
import SectionTopMenu from '../../shared/components/SectionTopMenu/SectionTopMenu';

const Review = () => {
  const {
   clientId, promotionId, categoryId, reviewId,
  } = useParams();

  const setCurrentClient = useStoreActions(actions => actions.setCurrentClient);
  const setCurrentPromotion = useStoreActions(actions => actions.setCurrentPromotion);

  setCurrentClient(clientId);
  setCurrentPromotion(promotionId);

  const currentClient = useStoreState(state => state.currentClient);
  const currentPromotion = useStoreState(state => state.currentPromotion);
  const [currentDelivery] = currentPromotion.deliveries.filter(delivery => delivery.categoryId === categoryId);
  const [currentReview] = currentDelivery.reviews.filter(review => review.id === reviewId);
  const [currentReviewContent] = currentPromotion.reviews.filter(review => review.id === reviewId);
  const [filters, setFilters] = useState(LiveFiltersMock);
  const [currentFilter, setCurrentFilter] = useState(categoryId);
  const [renders] = useState(currentReviewContent.content.filter(item => item.type === 'render'));
  const [rendersIa] = useState(currentReviewContent.content.filter(item => item.type === 'render-ia'));
  const [videos] = useState(currentReviewContent.content.filter(item => item.type === 'video'));
  const [videosIa] = useState(currentReviewContent.content.filter(item => item.type === 'video-ia'));
  const [panos] = useState(currentReviewContent.content.filter(item => item.type === 'panoramic'));
  const [orbits] = useState(currentReviewContent.content.filter(item => item.type === 'orbit'));
  const [solarSimulations] = useState(currentReviewContent.content.filter(item => item.type === 'solar-simulator'));
  const [filteredRenders, setFilteredRenders] = useState(renders.filter(item => item.category === currentFilter));
  const [filteredAiRenders, setFilteredAiRenders] = useState(rendersIa.filter(item => item.category === currentFilter));
  const [filteredVideos, setFilteredVideos] = useState(videos.filter(item => item.category === currentFilter));
  const [filteredAiVideos, setFilteredAiVideos] = useState(videosIa.filter(item => item.category === currentFilter));
  const [filteredPanos, setFilteredPanos] = useState(panos.filter(item => item.category === currentFilter));
  const [filteredOrbits, setFilteredOrbits] = useState(orbits.filter(item => item.category === currentFilter));
  // eslint-disable-next-line max-len
  const [filteredSolarSimulations, setFilteredSolarSimulations] = useState(solarSimulations.filter(item => item.category === currentFilter));

  const onFilterSelected = (selectedFilter) => {
    filters.forEach((filter, index) => {
      filters[index].active = filter.filter === selectedFilter;
    });

    setCurrentFilter(selectedFilter);
    setFilters(filters);

    setFilteredRenders(renders.filter(item => item.category === selectedFilter));
    setFilteredAiRenders(rendersIa.filter(item => item.category === selectedFilter));
    setFilteredVideos(videos.filter(item => item.category === selectedFilter));
    setFilteredAiVideos(videosIa.filter(item => item.category === selectedFilter));
    setFilteredPanos(panos.filter(item => item.category === selectedFilter));
    setFilteredOrbits(orbits.filter(item => item.category === selectedFilter));
    setFilteredSolarSimulations(solarSimulations.filter(item => item.category === selectedFilter));
  };

  return (
    <Fragment>
      <SectionTopMenu clientName={currentClient.name} promotionName={currentPromotion.name} />
      <ReviewHeader
        review={currentReview}
        closedReviews={currentDelivery.closedReviews}
        totalReviews={currentDelivery.totalReviews}
        category={currentFilter}
        headerImage={filteredRenders.length > 0 ? filteredRenders[0].src : currentPromotion.image}
      />
      <ReviewFilter
        filters={filters.filter(filter => filter.filter === categoryId)}
        onFilterSelected={onFilterSelected}
      />
      <ReviewGallery type="RENDERS" items={filteredRenders} />
      <ReviewGallery type="RENDERS IA" items={filteredAiRenders} />
      <ReviewGallery type="VIDEOS" items={filteredVideos} />
      <ReviewGallery type="VIDEOS IA" items={filteredAiVideos} />
      <ReviewGallery type="PANORAMIC TOUR" items={filteredPanos} />
      <ReviewGallery type="ORBIT TOUR" items={filteredOrbits} />
      <ReviewGallery type="SIMULADOR SOLAR" items={filteredSolarSimulations} />
    </Fragment>
  );
};

export default Review;
